module.exports = __webpack_public_path__ + "img/king-movement.a60ed7bd.gif";